import {
  collection,
  doc,
  documentId,
  getDoc,
  getDocs,
  orderBy,
  query,
  startAfter,
  limit as setLimit,
  where,
  onSnapshot,
  getCountFromServer,

} from "firebase/firestore";
import { getAuth, signInWithCustomToken } from "firebase/auth";

import Service from "./service";
import {
  appCheck,
  // appCheckToken,
  db,
} from "../config/fireBaseConfig";
import { cloudFunctionBaseUrl } from "./constants";
import { getToken } from "firebase/app-check";

export const getSingleDocument = async (collectionPath, docId, whereClause = null) => {
  if (!docId && !whereClause) {
    return {};
  }

  let docData = null;

  try {
    if (whereClause) {
      // Use 'where' clause for queries
      const collectionRef = collection(db, collectionPath);
      const q = query(collectionRef, where(...whereClause)); // Example: ['field', '==', 'value']
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        docData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      } else {
        return [];
      }
    } else if (docId) {
      // Fetch document by ID
      const docRef = doc(db, collectionPath, docId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        docData = { id: docSnap.id, ...docSnap.data() };
      } else {
        return [];
      }
    }
  } catch (error) {
    console.error("Error fetching document:", error);
    return [];
  }

  return docData || {};
};

export const authenticateWalletAddressAsync = async (
  walletAddress,
  appCheckToken,
  signature,
  setIsAuthenticated,
  setIsDisabled,
) => {
  const auth = getAuth();
  try {
    const { token } = await getAuthToken(
      signature,
      walletAddress,
      appCheckToken,
    );
    await signInWithCustomToken(auth, token);
    setIsAuthenticated(true);
    setIsDisabled(false);
  } catch (error) {
    let message = error.message;
    if (error.message?.includes("email-already-in-use")) {
      message = "Already Login!";
    }
    if (error.message?.includes("invalid-login-credentials")) {
      message = "Invalid credentials please contact support!";
    }
    const errorToThrow = new Error(message);
    errorToThrow.name = "AuthenticateError";
    throw errorToThrow;
  }
};

const getAuthToken = async (signature, walletAddress, appCheckToken) => {
  const response = await Service.postCall(
    cloudFunctionBaseUrl + "anonymousAuth",
    {
      sig: signature,
      walletAddress: walletAddress,
    },
    // {
    //   headers: {
    //     "X-Firebase-AppCheck": appCheckToken,
    //   },
    // }
  );
  return response.data;
};

export const getDocuments = async (
  collectionPath,
  orderByAttr,
  orderByOrder,
) => {
  const q = collection(db, collectionPath);
  const order = orderByAttr ? [orderByAttr, orderByOrder] : [documentId()];
  const finalQuery = query(q, orderBy(...order));
  const querySnapshot = await getDocs(finalQuery);

  const docs = [];
  querySnapshot.forEach((doc) => {
    const docData = doc.data();

    docData["id"] = doc.id;
    docs.push(docData);
  });

  return docs;
};

export const getPaginatedDocuments = async (
  collectionPath,
  orderByAttr = null,
  orderByOrder = 'asc',
  limit = 10,
  lastDoc = null // Optional parameter for pagination
) => {
  // Create the collection reference
  const collectionRef = collection(db, collectionPath);

  // Create the query
  let finalQuery;

  // Handle ordering and pagination
  if (orderByAttr) {
    finalQuery = query(
      collectionRef,
      orderBy(orderByAttr, orderByOrder),
      ...(lastDoc ? [startAfter(lastDoc)] : []), // Pagination support
      setLimit(limit) // Set limit for each page
    );
  } else {
    finalQuery = query(
      collectionRef,
      orderBy(documentId()),
      ...(lastDoc ? [startAfter(lastDoc)] : []), // Pagination support
      setLimit(limit)
    );
  }

  // Execute the query and get snapshot
  const querySnapshot = await getDocs(finalQuery);

  // Extract documents
  const docs = querySnapshot.docs.map((doc) => ({
    id: doc.id, // Include the document ID
    ...doc.data(),
  }));

  // Get the last visible document for pagination
  const lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

  // Return the documents and the last visible document
  return { docs, lastVisible };
};


export const AddTrxToDB = async (dataObj) => {
  try {
    const {token} = await getToken(appCheck, true);
    const funcToUse =
      dataObj.txType === "Claim Reward"
        ? "addClaimTransactionData"
        : "addTrxData";

    await Service.postCall(
      cloudFunctionBaseUrl + funcToUse,
      dataObj,
      {
        headers: {
          "X-Firebase-AppCheck": token,
        },
      }
    );

    if (dataObj.status === "completed") {
    window.location.href = "/my-account";
    }
  } catch (error) {
    console.error(error);
  }
};

export const fetchChange = (collectionName, docId, callback, handleWalletInfo, setIsSyncing, setIsFetchingMyAccountDetails, setIsSynced, walletAddress) => {
  // Reference to the specific Firestore document
  const docRef = doc(db, collectionName, docId);
  // Subscribe to changes in the document
  const unsubscribe = onSnapshot(
    docRef,
    async (snapshot) => {
      if (snapshot.exists()) {
        const prevBalance = Number(localStorage?.getItem("prevBalance")) || 0
        const lastUpdatedAt = Number(localStorage?.getItem("lastUpdatedAt")) || 0
        const tx = JSON.parse(localStorage?.getItem("trxData"));
        const data = { id: snapshot.id, ...snapshot.data() }; // Include doc ID and data
        const reward = data?.total_unclaimed_rewards + data?.total_unclaimed_comission

        callback(); // Pass updated data to the callback'
        handleWalletInfo()

        if((tx?.type === "STAKING" && data?.stake_value > prevBalance) || (tx?.type === "UNSTAKING" && data?.stake_value < prevBalance) || (tx?.type === "CLAIM REWARD" && reward === 0) || tx?.type === "CLAIM STAKE" && data?.realtime_update > lastUpdatedAt) {
          setIsSyncing(false)
          setIsSynced(true)
        }

      } else {
        console.log('Document does not exist!');
        setIsFetchingMyAccountDetails(false)
      }
    },
    (error) => {
      console.error('Error fetching document: ', error); // Handle errors
    }
  );

  // localStorage?.removeItems("trxData")

  // Return unsubscribe function for cleanup
  return unsubscribe;
};

export const fetchUserTransactions = async (userAddress, contract_address) => {
  try {
      // Define collection reference
      const transactionsRef = collection(db, `/vanar-dpos/data/user_data/${userAddress}/transactions`);

      // Query to filter by 'to' field
      const q = query(transactionsRef, where("to", "==", contract_address));

      // Fetch documents matching query
      const querySnapshot = await getDocs(q);

      // Map data into an array
      const userTrxHistory = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
      }));

      // Additional filter for unclaimed transactions
      const unClaimedTrx = userTrxHistory.filter(
          (trx) => trx?.claimed === false && trx?.to === contract_address
      );


      return unClaimedTrx;
  } catch (error) {
      console.error("Error fetching transactions:", error);
      return { allTransactions: [], unClaimedTrx: [] };
  }
};

export const fetchDocumentCount = async (collectionPath) => {
  const q = query(collection(db, collectionPath), where("stake_value", ">", 0));

  try {
    const snapshot = await getCountFromServer(q);
    return snapshot.data().count; // Returns the count of documents
  } catch (error) {
    console.error("Error fetching document count:", error);
    return 0;
  }
};
